// removed by extract-text-webpack-plugin
module.exports = {"vpUploadError":"vpUploadError___3opAp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/UploadError.module.less
// module id = 2580
// module chunks = 29